export enum PurchaseType {
  OldSubscription = 1,
  AdditionalGenerations = 2,
  MonthSubscription = 4,
  SixMonthSubscription = 5,
  YearSubscription = 6,
  MonthSubscriptionWithGenerations = 7,
  SixMonthSubscriptionWithGenerations = 8,
  YearSubscriptionWithGenerations = 9,
}

export const Purchases = {
  [PurchaseType.OldSubscription]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.AdditionalGenerations]: {
    ymEventName: 'Subscribed AI BG gen',
  },
  [PurchaseType.MonthSubscription]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.SixMonthSubscription]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.YearSubscription]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.MonthSubscriptionWithGenerations]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.SixMonthSubscriptionWithGenerations]: {
    ymEventName: 'subscribed',
  },
  [PurchaseType.YearSubscriptionWithGenerations]: {
    ymEventName: 'subscribed',
  },
}
